var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineChartSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "vuesax/outline/chart-success"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v4a.75.75 0 01-1.5 0V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h4a.75.75 0 010 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M13 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v4a.75.75 0 01-1.5 0V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h4a.75.75 0 010 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M7 14.69a.755.755 0 01-.75-.75v-3.21A.755.755 0 017 9.98a.755.755 0 01.75.75v3.21a.749.749 0 01-.75.75zM17 14.69a.755.755 0 01-.75-.75v-3.21a.755.755 0 01.75-.75.755.755 0 01.75.75v3.21a.749.749 0 01-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M13 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v4a.75.75 0 01-1.5 0V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h4a.75.75 0 010 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M17.58 21.747a.749.749 0 01-.53-.22l-1.58-1.567a.75.75 0 011.06-1.06l1.01 1 2.9-3.39a.747.747 0 011.06-.08.756.756 0 01.08 1.06l-3.42 4a.754.754 0 01-.54.26zM12 14.25a.755.755 0 01-.75-.75v-3a.755.755 0 01.75-.75.755.755 0 01.75.75v3a.755.755 0 01-.75.75z"
  }))));
}
export default SvgVuesaxOutlineChartSuccess;